import Vue from 'vue'
import funcDialog from './func-dialog.vue'

let $instance = null;
let $Constructor = Vue.extend(funcDialog);

let Caller = () => {
  $instance = new $Constructor();
  $instance.$mount();
}

Caller.prototype.show = function() {
  document.body.appendChild($instance.$el);
  $instance.open(...arguments);
}

Caller.prototype.addEventListener = function(func) {
  if(func && typeof func === 'function'){
    $instance.confirmCallback = (status)=>{
      // let args = arguments;
      document.body.removeChild($instance.$el)
      return func(status)
    };
  }else{
    throw 'addEventListener must be a function!!!'
  }
}

export default new Caller();

// export default {
//   install: vue => {
//     vue.prototype.$funcDialog = new Caller();
//   }
// }